/*
  PLEASE DON'T EDIT THIS FILE.
  IF YOU NEED TO OVERRIDE IT,
  DO IT IN THE COMPONENT.
*/

import { useEffect, useState } from 'react'

const useGridEffect = (isOnlyForSuperAdmin, isSuperAdmin, currentAdmin, filter, config) => {
  const [gridConfig, setGridConfig] = useState(null)

  useEffect(() => {
    if (isOnlyForSuperAdmin && !isSuperAdmin) {
      return <div>You don't have permission to view this content</div>
    }
    const configOptions = {
      client_id: currentAdmin.client_id, // *** > > > PLEASE NEVER, EVER DELETE THIS LINE < < <  ***
      filter,
      sqlFields: [] // only pass it if you need to override the config file sqlFields
    }
    setGridConfig(prevConfig => config(configOptions))
  }, [filter, isOnlyForSuperAdmin, isSuperAdmin, currentAdmin, config])

  return gridConfig
}

export default useGridEffect
